/**
 * 存放全局公用状态
 */

const state = {}

const getters = {}

const actions = {}

const mutations = {}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
